// Стек открытых окон (Sheet): блокировка прокрутки фона и системная «Назад» (мобильный аудит, M-11).
//
// Телефон: окно открыто — страница под ним не должна прокручиваться, а «Назад» (жест, кнопка
// Android, «Назад» Telegram/MAX) должна закрывать окно, а не выгружать приложение. Для этого
// при открытии кладём запись в историю, по popstate закрываем верхнее окно.

type Layer = { id: number; close: () => void; history: boolean };
const stack: Layer[] = [];
let seq = 0;
let savedScroll = 0;
let ignorePop = 0;

function lockBody() {
  savedScroll = window.scrollY;
  const b = document.body.style;
  b.position = "fixed"; b.top = `-${savedScroll}px`; b.left = "0"; b.right = "0"; b.width = "100%";
  document.documentElement.dataset.sheet = "open";
}

function unlockBody() {
  const b = document.body.style;
  b.position = ""; b.top = ""; b.left = ""; b.right = ""; b.width = "";
  delete document.documentElement.dataset.sheet;
  window.scrollTo(0, savedScroll);
}

window.addEventListener("popstate", () => {
  if (ignorePop > 0) { ignorePop -= 1; return; }
  const top = stack[stack.length - 1];
  if (top?.history) top.close();
});

window.addEventListener("keydown", (e) => {
  if (e.key !== "Escape" || !stack.length) return;
  e.stopPropagation();
  stack[stack.length - 1].close();
}, true);

/** Регистрирует открытое окно; вернёт функцию снятия. history — связать с «Назад». */
export function pushLayer(close: () => void, { history = true } = {}): () => void {
  const layer: Layer = { id: ++seq, close, history };
  if (!stack.length) lockBody();
  stack.push(layer);
  if (history) window.history.pushState({ anyskinSheet: layer.id }, "");
  return () => {
    const i = stack.findIndex((l) => l.id === layer.id);
    if (i < 0) return;
    stack.splice(i, 1);
    // Закрыли кнопкой, а не «Назад» — убираем свою запись из истории.
    if (history && window.history.state?.anyskinSheet === layer.id) { ignorePop += 1; window.history.back(); }
    if (!stack.length) unlockBody();
  };
}

export const hasOpenLayer = () => stack.length > 0;
